// Table cells shared by CanSupplyTable and MissingTable, so both tables render
// specs, scores, quantities and the inline correction identically.
import ProductSearchDropdown from "./ProductSearchDropdown";
import { pct, scoreTone } from "./utils";
import "./Matching.css";

// [spec key on the LV item, short label shown in the cell]
export const BASE_SPEC_FIELDS = [
  ["Wanddicke", "Wanddicke"],
  ["Rohdichteklasse", "RDK"],
  ["Druckfestigkeitsklasse", "DFK"],
];

export function SpecsCell({ specs = {}, fields = BASE_SPEC_FIELDS }) {
  return (
    <td className="mt-specs">
      {fields.map(([key, label]) =>
        specs[key] ? (
          <div key={key}>
            <span className="mt-spec-key">{label}:</span> {specs[key]}
          </div>
        ) : null,
      )}
    </td>
  );
}

export function ScoreBadge({ score }) {
  return <span className={`ds-badge ds-badge--${scoreTone(score)}`}>{pct(score)}</span>;
}

export function EditedBadge() {
  return <span className="ds-badge ds-badge--warning mt-inline-badge">edited</span>;
}

export function ReqQtyCell({ result }) {
  const lv = result.lv_item;
  return (
    <td className="mt-req-qty">
      {result.required_quantity != null ? (
        <>
          <div>{lv.menge} {lv.einheit}</div>
          <div className="mt-req-qty-calc">
            → {result.required_quantity.toLocaleString("de-DE")} Stk.
          </div>
        </>
      ) : "—"}
    </td>
  );
}

// Product search spanning the product columns while a row is being corrected.
export function EditProductCell({ colSpan, catalogProducts, onSelect, onCancel }) {
  return (
    <td colSpan={colSpan}>
      <div className="mt-edit-row">
        <ProductSearchDropdown
          products={catalogProducts}
          disabled={catalogProducts.length === 0}
          onSelect={onSelect}
        />
        <button
          type="button"
          className="ds-btn ds-btn--ghost ds-btn--sm"
          title="Cancel"
          aria-label="Cancel"
          onClick={onCancel}
        >
          ✕
        </button>
      </div>
    </td>
  );
}

// Trailing column with the row's "edit" toggle (hidden while editing).
export function EditToggleCell({ isEditing, title, onEdit }) {
  return (
    <td className="mt-edit-col">
      {!isEditing && (
        <button
          type="button"
          className="ds-btn ds-btn--ghost ds-btn--sm"
          title={title}
          aria-label={title}
          onClick={onEdit}
        >
          ✎
        </button>
      )}
    </td>
  );
}
